import { render, staticRenderFns } from "./LegendaChartArrecadacao.vue?vue&type=template&id=bc4623a6"
import script from "./LegendaChartArrecadacao.vue?vue&type=script&lang=js"
export * from "./LegendaChartArrecadacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports